export default class FormObserver {
  constructor() {
    this.$observers = [];
  }

  subscribe(name, fn) {
    this.$observers.push({
      name,
      fn,
    });
  }

  unsubscribe(fn) {
    this.$observers = this.$observers.filter(subscriber => subscriber.fn !== fn);
  }

  broadcast(name, value, old) {
    this.$observers
      .filter(subscriber => subscriber.name === name)
      .forEach(subscriber => subscriber.fn(value, old));
  }

  on(name, fn) {
    this.subscribe(name, fn);
  }

  once(name, fn) {
    const self = this;
    const once = (value, old) => {
      fn(value, old);
      self.unsubscribe(once);
    };
    self.subscribe(name, once);
  }

  emit(name, value, old) {
    this.broadcast(name, value, old);
  }
}
